import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from "@angular/material/snack-bar";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "app-snackbar",
	standalone: true,
	imports: [CommonModule, MatSnackBarModule, TranslateModule],
	template: `
		@if (data.titlePlaceholder) {
		<div
			class="before-ico"
			[ngClass]="data.status === 'error' ? 'alert-solid-before text-red' : (data.status === 'success' ? 'success-solid-before' : 'info-solid-before') + ' text-blue' "
		>
			<strong>{{ data.titlePlaceholder | translate }}</strong>
		</div>
		}
		@if (data.messagePlaceholder) {
			<span class="ms-2 ps-4">
				{{ data.messagePlaceholder | translate }}
			</span>
		}
	`
})
export class SnackBarComponent {
	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { status: "success" | "info" | "error"; titlePlaceholder: string; messagePlaceholder: string; }) { }
}